
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class MeltingGrid extends Serenity.EntityGrid<MeltingRow, any> {
        protected getColumnsKey() { return 'Inventory.Melting'; }
        protected getDialogType() { return MeltingDialog; }
        protected getIdProperty() { return MeltingRow.idProperty; }
        protected getInsertPermission() { return MeltingRow.insertPermission; }
        protected getLocalTextPrefix() { return MeltingRow.localTextPrefix; }
        protected getService() { return MeltingService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected addButtonClick() {

            let now = new Date(); 

            var voucherNo = FormatHelper.GetVoucherNo(63);

            var userDefinition = Q.Authorization.userDefinition;
            var autoposting = OMS.VoucherMasterRow.getLookup().itemById[63].AutoPosting;
            this.editItem(<MeltingRow>{
                VoucherNo: voucherNo,
                Line_No: 0,
                CompanyId: userDefinition.CompanyId,
                FinancialYearId: userDefinition.FinancialYearId,
                UserId: userDefinition.UserId,
                CurrencyId: userDefinition.CurrencyId,
                VoucherTypeId: 63,

                TransDate: now.toString(),
                AutoPosting: autoposting
            });
        }
    }
}